import { useSearchParams } from "react-router-dom";

const tabs = [
  { id: "summary", label: "Summary" },
  { id: "details", label: "Details" },
];

export default function ShipmentProductsTabs({ summary, details }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = searchParams.get("tab");
  const tab = requested === "details" ? "details" : "summary";

  const selectTab = (next) => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set("tab", next);
    setSearchParams(nextParams, { replace: true });
  };

  return (
    <div>
      <div
        role="tablist"
        aria-label="Shipment products"
        className="flex gap-4 border-b border-gray-200 px-2"
      >
        {tabs.map((item) => {
          const selected = tab === item.id;
          return (
            <button
              key={item.id}
              type="button"
              role="tab"
              id={`shipment-products-tab-${item.id}`}
              aria-selected={selected}
              aria-controls={`shipment-products-panel-${item.id}`}
              tabIndex={selected ? 0 : -1}
              onClick={() => selectTab(item.id)}
              className={`-mb-px border-b-2 px-1 py-2 text-sm font-medium ${
                selected
                  ? "border-indigo-500 text-indigo-600"
                  : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
            >
              {item.label}
            </button>
          );
        })}
      </div>
      <div
        role="tabpanel"
        id="shipment-products-panel-summary"
        aria-labelledby="shipment-products-tab-summary"
        hidden={tab !== "summary"}
        className="pt-2"
      >
        {summary}
      </div>
      <div
        role="tabpanel"
        id="shipment-products-panel-details"
        aria-labelledby="shipment-products-tab-details"
        hidden={tab !== "details"}
        className="pt-2"
      >
        {details}
      </div>
    </div>
  );
}
